export const productsAPI = [
    {
        id: 'abc1',
        name: 'Amoxicillin',
        price: 25.00,
        category: 'pharmacy',
        tags: [
            'health', 'pharmacy', 'pills'
        ],
        img: '/assets/img/products/shop-1.jpg',
        summary: 'It is a paradisematic country, in which roasted parts of sentences fly into your mouth.'
    },
    {
        id: 'abc2',
        name: 'Pharmacy',
        price: 35.00,
        category: 'pharmacy',
        tags: [
            'health', 'pharmacy', 'solution'
        ],
        img: '/assets/img/products/shop-2.jpg',
        summary: 'When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove.'
    },
    {
        id: 'abc3',
        name: 'Electric Thermometer',
        price: 18.00,
        category: 'health',
        tags: [
            'health', 'pharmacy', 'tanometer'
        ],
        img: '/assets/img/products/shop-3.jpg',
        summary: 'A small river named Duden flows by their place and supplies it with the necessary regelialia.'
    },
    {
        id: 'abc4',
        name: 'Face Mask',
        price: 2.00,
        category: 'health',
        tags: [
            'health', 'pharmacy', 'face mask'
        ],
        img: '/assets/img/products/shop-4.jpg',
        summary: 'It is a paradisematic country, in which roasted parts of sentences fly into your mouth.'
    },
    {
        id: 'abc5',
        name: 'Flemoclav',
        price: 32.00,
        category: 'Drugs',
        tags: [
            'health', 'pharmacy', 'pills'
        ],
        img: '/assets/img/products/shop-5.jpg',
        summary: 'It is a paradisematic country, in which roasted parts of sentences fly into your mouth.'
    },
    {
        id: 'abc6',
        name: 'Hand Sanitizer',
        price: 12.00,
        category: 'pharmacy',
        tags: [
            'health', 'pharmacy', 'sanitizer'
        ],
        img: '/assets/img/products/shop-6.jpg',
        summary: 'When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane.'
    },
    {
        id: 'abc7',
        name: 'JQ-28',
        price: 23.00,
        category: 'drugs',
        tags: [
            'health', 'pharmacy', 'drugs'
        ],
        img: '/assets/img/products/shop-7.jpg',
        summary: 'It is a paradisematic country, in which roasted parts of sentences fly into your mouth.'
    },
    {
        id: 'abc8',
        name: 'Panklav',
        price: 22.00,
        category: 'drugs',
        tags: [
            'health', 'pharmacy', 'pills'
        ],
        img: '/assets/img/products/shop-8.jpg',
        summary: 'It is a paradisematic country, in which roasted parts of sentences fly into your mouth.'
    }
]